<template>
  <Drawer
    :value="open"
    @on-close="$emit('on-close')"
    :class-name="open ? 'ai-chat-con-wrap' : ''"
    ref="wrap"
    footer-hide
    :title="title"
    :width="$slots.default ? (hideAiChat ? 600 : 1200) : 600"
    :styles="{ padding: 0 }"
    :mask-closable="false"
  >
    <div class="ai-chat-con">
      <div  class="ai-chat-slot" v-if="$slots.default">
        <slot></slot>
      </div>
      <iframe
        class="ai-chat-iframe"
        v-if="open && !hideAiChat"
        style="width: 100%; height: 100%"
        ref="iframe"
        frameborder="0"
        :src="aiChatUrl"
      ></iframe>
    </div>
    <template v-slot:header>
      <slot name="title"></slot>
    </template>
  </Drawer>
  <!-- <Modal
    v-else
    :value="open"
    @on-cancel="$emit('on-close')"
    :title="title"
    :width="600"
    footer-hide
  >
    <slot></slot>
  </Modal> -->
</template>

<script>
import { getToken } from '@/utils/auth'
import { wrap } from 'lodash'

export default {
  data() {
    return {
      aiChatUrl: `${webConfig.api.aiChat}?t=${new Date().getTime()}`,
      isLoaded: false,
      events: [],
      wrapClick: false,
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    aiShow: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    quote: {
      type: Object,
    },
    hideAiChat: {
      type: Boolean,
      default: false,
    }
  },

  created() {
    window.addEventListener('message', this.aichatMessage)
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('message', this.aichatMessage)
  },
  methods: {
    sendQuote() {
      const IFrame = this.$refs.iframe;
      IFrame.contentWindow.postMessage({
        type: 'aichat.quote',
        data: this.quote,
      }, this.aiChatUrl)
    },
    onDebugger() {
      const IFrame = this.$refs.iframe;
      IFrame.contentWindow.postMessage({
        type: 'aichat.init',
        token: getToken(),
      }, this.aiChatUrl);
    },
    aichatMessage(e) {
      if (!e || !e.data) return
      const { data, type } = e.data
      if (type === 'aichat.loaded') {
        this.onDebugger()
        this.sendQuote()
        this.isLoaded = true
        while (this.events.length) {
          this.events.pop().call(this)
        }
      } else if (type === 'aichat.insert') {
        this.$emit('on-insert', data)
      }
    },
    sendMessage(data) {
      if (!this.isLoaded) {
        this.events.push(() => {
          this.sendMessage(data)
        })
      } else {
        const IFrame = this.$refs.iframe;
        setTimeout(() => {
          IFrame.contentWindow.postMessage({
            type: 'aichat.send',
            data,
          }, this.aiChatUrl)
        }, 100) 

      }
    },
    wrapMouseDown() {
      const className = event.target.getAttribute('class');
      if (className && className.indexOf('ai-chat-con-wrap') > -1) {
        this.wrapClick = true
      }
    },
    wrapMouseUp() {
      const className = event.target.getAttribute('class')
      if (className && className.indexOf('ai-chat-con-wrap') > -1 && this.wrapClick) {
        this.$emit('on-close')
      }
      this.wrapClick = false
    },
  },
  watch: {
    open(val) {
      if (val) {
        setTimeout(() => {
          document.getElementsByClassName('ai-chat-con-wrap')[0].addEventListener('mousedown', this.wrapMouseDown)
          document.getElementsByClassName('ai-chat-con-wrap')[0].addEventListener('mouseup', this.wrapMouseUp)
        }, 100)
        this.sendQuote()
      } else {
        document.getElementsByClassName('ai-chat-con-wrap')[0].removeEventListener('mousedown', this.wrapMouseDown)
        document.getElementsByClassName('ai-chat-con-wrap')[0].removeEventListener('mouseup', this.wrapMouseUp)
      }
    },
    quote(val) {
      if (!val) return;
      this.sendQuote()
    }
  },
}
</script>
<style lang="scss" scoped>
.ai-chat-con {
  display: flex;
  height: 100%;
}
.ai-chat-slot {
  overflow-y: auto;
  width: 600px;
  flex: 1;
}
.ai-chat-iframe {
  width: 400px;
  flex: 1;
}
</style>